/* eslint-disable multiline-ternary */
// ** React Imports
import { Fragment, useEffect, useRef, useState } from 'react'
// ** Table Data & Columns
import { calcularTotales, columns } from './components/data'
import '@styles/react/libs/tables/react-dataTable-component.scss'
// ** Third Party Components
import ReactPaginate from 'react-paginate'
import DataTable from 'react-data-table-component'
import { ChevronDown } from 'react-feather'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

// ** Reactstrap Imports
import {
  Card,
  Input,
  CardHeader,
  Button,
  InputGroup,
  InputGroupText,
} from 'reactstrap'
import './style.scss'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import CreateUserForm from './components/create-user'
import CreateProductsForm from './components/create-products-services'
import DeleteProducService from './components/delete-item/delete-item'
import EditProducService from './components/edit-item/edit-item'
import Comments from './components/comments'
import toast from 'react-hot-toast'
import CreateUserCreditDebitForm from './components/create-user-credit-debit'
import { setDatasBillAction, setInitialData } from './store'
import {
  getCities,
  getDistricts,
  getCountries,
  getDepartments,
  getDocumentTypes,
  getEconomicActivities,
  getMeasurementUnit,
  getPaymentMethod,
  getTerms,
  getOperationConditions,
  getSaleTypes,
  getTaxpayerTypes,
  getPersonTypes,
} from './thunks'
import { getClients } from '../customer-master/thunks'
import { getProducts } from '../product-services-master/thunks'
import { getIssuerInfo } from '../business-manager/thunks'
const MySwal = withReactContent(Swal)

const invoiceIssuance = ({}) => {
  // ** States
  const [showDeleteAreaModal, setShowDeleteAreaModal] = useState(false)
  const [discountValue, setDiscountValue] = useState(null)
  const [addDiscountValue, setAddInputValue] = useState(null)

  /* Selectores */
  const { receptor } = useSelector((state) => state.invoiceIssuance)
  const userInfo = useSelector((state) => state.businessManager)

  const dispatch = useDispatch()

  const userFormRef = useRef(null)
  const productFormRef = useRef(null)

  const handleValidateForm = () => {
    if (userFormRef.current) {
      userFormRef.current.validateForm()
    }
  }

  const { invoiceId } = useParams()
  const dteType = receptor?.dteType?.value === '08'
  const dataTable = []

  const params = useParams()
  const [currentPage, setCurrentPage] = useState(0)

  const { products } = useSelector((state) => state.invoiceIssuance)

  const [filteredData, setFilteredData] = useState(products)

  const [totalTable, setTotalsTable] = useState({
    totalGravado: 0,
    impuestoValorAgregado: 13,
    IVARetenido: 0,
    IVAPercibido: 0,
    retencionRenta: 0,
    subTotal: 0,
    total: 0,
  })
  const [totalRecords, setTotalRecords] = useState(dataTable.length || 0)

  const [rowEdit, setRowEdit] = useState(null)
  const [showEditAreaModal, setShowEditAreaModal] = useState(false)
  const [isRetained, setIsRetained] = useState(false)
  const [isPerceived, setIsPerceivedl] = useState(false)

  /* inicializar catalogos */
  useEffect(() => {
    dispatch(getIssuerInfo())
    dispatch(getDepartments())
    dispatch(getEconomicActivities())
    dispatch(getDocumentTypes())
    dispatch(getMeasurementUnit())
    dispatch(getSaleTypes())
    dispatch(getPaymentMethod())
    dispatch(getTerms())
    dispatch(getOperationConditions())
    dispatch(getClients())
    dispatch(getProducts())
    dispatch(getCountries())
    dispatch(getTaxpayerTypes())
    dispatch(getPersonTypes())
  }, [dispatch])

  useEffect(() => {
    if (receptor?.department?.value) {
      dispatch(getCities(receptor?.department?.value))
    }
  }, [dispatch, receptor?.department?.value])

  useEffect(() => {
    if (receptor?.department?.value && receptor?.municipality?.value) {
      dispatch(
        getDistricts({
          departmentCode: receptor?.department?.value,
          municipalityCode: receptor?.municipality?.value,
        })
      )
    }
  }, [dispatch, receptor?.department?.value, receptor?.municipality?.value])

  const UserType = userInfo.data?.largeConsumer?.value

  useEffect(() => {
    // CAT contribuyentes: 01 = Gran contribuyente. "No pertenecer a esa
    // clasificación" es, por tanto, cualquier valor distinto de 01
    const emisorEsGranContribuyente = UserType === '01'
    const receptorEsGranContribuyente =
      receptor?.largeConsumer?.value === '01'

    // Art. 162 CT: retiene el gran contribuyente que adquiere "DE OTROS
    // CONTRIBUYENTES QUE NO PERTENEZCAN A ESA CLASIFICACIÓN". Es decir, el
    // adquirente (receptor del CCF) debe ser gran contribuyente y el emisor no
    setIsRetained(
      receptorEsGranContribuyente &&
        !emisorEsGranContribuyente &&
        (receptor?.dteType?.value === '03' ||
          receptor?.emisionType === '03')
    )

    // Art. 163 CT: percibe el gran contribuyente que transfiere bienes "A
    // OTROS CONTRIBUYENTES QUE NO PERTENEZCAN A ESA CLASIFICACIÓN" — incluye
    // al mediano (02), al pequeño (03) y a otros (04)
    setIsPerceivedl(
      emisorEsGranContribuyente &&
        Boolean(receptor?.largeConsumer?.value) &&
        !receptorEsGranContribuyente
    )

    if (
      params?.invoiceId !== 'note' &&
      params?.invoiceId !== 'debit-note'
    ) {
      setFilteredData([])
    }
  }, [receptor])

  useEffect(() => {
    setFilteredData(products)
  }, [products])

  const isExempt =
    receptor?.dteType?.value === '11' ||
    receptor?.dteType?.value === '01' ||
    receptor?.dteType?.value === '14' ||
    receptor?.dteType?.value === '08'

  const [filterData, setFilterData] = useState({
    pageNumber: 1,
    pageSize: 25,
    status: +params.statusDocument,
  })

  const onFilter = (filterProp) => {
    setFilterData({ ...filterData, ...filterProp })
  }

  useEffect(() => {
    setTotalRecords(dataTable.length)
  }, [dataTable])

  useEffect(() => {
    dispatch(setInitialData())
  }, [])

  useEffect(() => {
    setTotalsTable(
      calcularTotales(
        filteredData,
        isExempt,
        isRetained,
        isPerceived,
        receptor
      )
    )
    dispatch(
      setDatasBillAction({
        products: filteredData,
        total: calcularTotales(
          filteredData,
          isExempt,
          isRetained,
          isPerceived,
          receptor
        ),
      })
    )
  }, [filteredData, addDiscountValue, isPerceived, isRetained])

  const toggleDeleteAreaModal = (show, row) => {
    setShowDeleteAreaModal(show)

    setRowEdit(row)
  }

  const toggleEditAreaModal = (show, row) => {
    setShowEditAreaModal(show)
    setRowEdit(row)
  }

  // ** Function to handle Pagination
  const handlePagination = (page) => {
    setCurrentPage(page.selected)
  }

  useEffect(() => {
    //getDocuments();
  }, [currentPage])

  // ** Pagination Previous Component
  const Previous = () => {
    return (
      <Fragment>
        <span className="align-middle d-none d-md-inline-block">
          Anterior
        </span>
      </Fragment>
    )
  }

  // ** Pagination Next Component
  const Next = () => {
    return (
      <Fragment>
        <span className="align-middle d-none d-md-inline-block">
          Siguiente
        </span>
      </Fragment>
    )
  }

  const discountHandleChange = (event) => {
    const value = event.target?.value ? event.target?.value : undefined
    if (value >= 0 && value <= 100) {
      setDiscountValue(event.target.value)
    } else {
      // Puedes agregar alguna lógica para manejar valores inválidos
      toast.error('El valor debe estar entre 0 y 99')
    }
  }

  function calculateSubTotal(price, discount, quantity, accept) {
    const userType = '01'

    const IVA_RATE =
      receptor?.dteType?.value === '11' ||
      receptor?.dteType?.value === '03' ||
      receptor?.dteType?.value === '06' ||
      receptor?.dteType?.value === '01' ||
      receptor?.dteType?.value === '14'
        ? 0
        : 0.13
    let totalGravado = 0

    if (accept || true) {
      const totalDiscount = (price * discount) / 100
      const totalTax = (price - totalDiscount) * IVA_RATE
      const total = (price - totalDiscount + totalTax) * quantity
      totalGravado = total
    } else {
      const totalDiscount = (price * discount) / 100

      const total = (price - totalDiscount) * quantity
      totalGravado += total
    }

    return totalGravado
  }

  const AdddiscountHandleChange = () => {
    setAddInputValue(discountValue)
    const updatedData = filteredData.map((item) => {
      return {
        ...item,
        discount: discountValue,
      }
    })
    setFilteredData(updatedData)
    setTotalsTable(
      calcularTotales(
        updatedData,
        isExempt,
        isRetained,
        isPerceived,
        receptor
      )
    )
  }

  const CustomPagination = () => (
    <ReactPaginate
      previousLabel={<Previous />}
      nextLabel={<Next />}
      forcePage={currentPage}
      onPageChange={(page) => handlePagination(page)}
      pageCount={Math.ceil(totalRecords / 25)}
      breakLabel={'...'}
      pageRangeDisplayed={2}
      marginPagesDisplayed={2}
      activeClassName={'active'}
      pageClassName={'page-item'}
      nextLinkClassName={'page-link'}
      nextClassName={'page-item next'}
      previousClassName={'page-item prev'}
      previousLinkClassName={'page-link'}
      pageLinkClassName={'page-link'}
      breakClassName="page-item"
      breakLinkClassName="page-link"
      containerClassName={
        'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'
      }
    />
  )

  // Pie de tabla personalizado
  const Footer = () => {
    const montoMoneda = (valor) =>
      Number(valor ?? 0).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })

    const esSujetoExcluido =
      receptor?.dteType?.value === '14' || receptor?.emisionType === '14'

    // El FSEE es el único que lleva retención de renta; el resto usa
    // retención/percepción de IVA. calcularTotales devuelve ambas cosas en
    // "retencionRenta" según el tipo de documento, así que se separan aquí
    const ivaRetenidoUI = esSujetoExcluido ? 0 : totalTable?.IVARetenido
    const ivaPercibidoUI = esSujetoExcluido ? 0 : totalTable?.IVAPercibido
    const retencionRentaUI = esSujetoExcluido
      ? totalTable?.retencionRenta
      : 0

    // Misma fórmula que el DTE: regla 2 (CCFE) y regla 6 (FSEE)
    const totalPagarUI = esSujetoExcluido
      ? Number(totalTable?.total ?? 0) - Number(retencionRentaUI ?? 0)
      : Number(totalTable?.total ?? 0) +
        Number(ivaPercibidoUI ?? 0) -
        Number(ivaRetenidoUI ?? 0)

    const footerData = [
      {
        name: isExempt ? 'Sumas' : 'Total gravado',
        value: (receptor?.dteType?.value === '03' ||
        receptor?.dteType?.value === '06'
          ? totalTable?.subTotal.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : totalTable?.totalGravado
        ).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        style: { backgroundColor: '#F3F2F7' },
      },
      {
        name: 'Impuesto al valor agregado 13%',
        value:
          receptor?.dteType?.value === '01' ||
          receptor?.dteType?.value === '14'
            ? '0.00'
            : totalTable?.impuestoValorAgregado.toLocaleString('en-US'),
        style: { backgroundColor: '#F3F2F7' },
      },
      {
        // Retención de IVA 1% (art. 162 CT). Es el valor que viaja como
        // resumen.ivaRete en el DTE
        name: 'IVA retenido',
        value: montoMoneda(ivaRetenidoUI),
        style: { backgroundColor: '#F3F2F7' },
      },
      {
        // Percepción de IVA 1% (art. 163 CT) -> resumen.ivaPerci
        name: 'IVA percibido',
        value: montoMoneda(ivaPercibidoUI),
        style: { backgroundColor: '#F3F2F7' },
      },
      {
        // Retención de renta: solo aplica al FSEE (#147) -> resumen.reteRenta
        name: 'Retención renta',
        value: montoMoneda(retencionRentaUI),
        style: { backgroundColor: '#F3F2F7' },
      },
      {
        name: 'Sub total',
        value:
          receptor?.dteType?.value === '01'
            ? (totalTable?.total).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : (totalTable?.totalGravado /*- totalTable?.IVARetenido - totalTable?.IVAPercibido*/)
                .toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }),
        style: { backgroundColor: '#F3F2F7' },
      },
      {
        name: 'Total',
        value: montoMoneda(totalPagarUI),
        style: { backgroundColor: '#6E6B7B', color: '#FFF' },
      },
    ]

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '10px',
          background: '#FFF',
        }}
      >
        <table style={{ width: '100%' }}>
          <tbody>
            {footerData.map((item, index) => (
              <tr
                key={index}
                style={{
                  borderTop: '1px solid #DDD',
                  borderBottom: '1px solid #DDD',
                  ...item.style,
                }}
              >
                <td style={{ padding: '5px 10px', fontWeight: 'bold' }}>
                  {item.name}
                </td>
                <td style={{ padding: '5px 10px', textAlign: 'right' }}>
                  $ {item.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <Fragment>
      {invoiceId !== 'note' && invoiceId !== 'debit-note' ? (
        <CreateUserForm
          onFilter={onFilter}
          ref={userFormRef}
        />
      ) : (
        <CreateUserCreditDebitForm
          onFilter={onFilter}
          ref={userFormRef}
        />
      )}
      <CreateProductsForm
        onFilter={onFilter}
        filteredData={filteredData}
        setFilteredData={setFilteredData}
        ref={productFormRef}
      />

      <Card>
        {filteredData.length > 0 && (
          <CardHeader className="flex-md-row flex-column align-md-items-center align-items-start border-bottom"></CardHeader>
        )}
        {filteredData.length > 0 && (
          <>
            <div className={`react-dataTable master-view-batch-table`}>
              <DataTable
                noHeader
                pagination
                columns={columns(
                  toggleEditAreaModal,
                  toggleDeleteAreaModal,
                  calculateSubTotal,
                  dteType
                )}
                paginationPerPage={25}
                className="react-dataTable"
                responsive={true}
                sortIcon={<ChevronDown size={10} />}
                paginationComponent={CustomPagination}
                paginationDefaultPage={currentPage + 1}
                data={filteredData}
              />
            </div>
            <Footer />
            {!dteType && (
              <div
                style={{
                  marginRight: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  height: '100px',
                }}
              >
                {invoiceId !== 'note' && invoiceId !== 'debit-note' && (
                  <>
                    <div style={{ marginRight: '16px' }}>
                      <InputGroup>
                        <Input
                          type="number"
                          value={discountValue}
                          onChange={discountHandleChange}
                        />
                        <InputGroupText>%</InputGroupText>
                      </InputGroup>
                    </div>
                    <Button
                      color="primary"
                      outline
                      onClick={AdddiscountHandleChange}
                    >
                      Agregar descuento
                    </Button>
                  </>
                )}
              </div>
            )}
          </>
        )}
      </Card>

      <Comments
        onValidateForm={handleValidateForm}
        resetClientForm={userFormRef}
        setFilteredData={setFilteredData}
        resetProdForm={productFormRef}
      />
      <EditProducService
        isOpen={showEditAreaModal}
        handleClose={toggleEditAreaModal}
        item={rowEdit}
        itemList={filteredData}
        setItem={setFilteredData}
        invoiceId={invoiceId}
      />

      <DeleteProducService
        isOpen={showDeleteAreaModal}
        handleClose={toggleDeleteAreaModal}
        item={rowEdit}
        itemList={filteredData}
        setItem={setFilteredData}
      />
    </Fragment>
  )
}

export default invoiceIssuance
